import { useEffect, useState } from 'react';
import { getRequest } from '../helpers/apiHandler';

const useFBAuthenticated = (accessToken) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkAuthToken = async () => {
      if (!accessToken?.token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        const payload = {
          headers: { Authorization: accessToken.token },
        };

        getRequest('/v2/whatsapp/fb-auth', payload, (res) => {
          if (!isMounted) return;

          setIsAuthenticated(res.success || false);
          setIsLoading(false);
        });
      } catch (error) {
        if (!isMounted) return;
        console.error('FB Auth check failed:', error);
        setIsAuthenticated(false);
        setIsLoading(false);
      }
    };

    setIsLoading(true);
    checkAuthToken();

    return () => {
      isMounted = false;
    };
  }, [accessToken?.token]);

  return { isAuthenticated, isLoading };
};

export default useFBAuthenticated;
